import { Routes } from '@angular/router';
import { ServicesContainerComponent } from './services-container/services-container.component';
import { SoftwareDevelopmentComponent } from './software-development/software-development.component';
import { MobileAppDevelopmentComponent } from './mobile-app-development/mobile-app-development.component';
import { WebDevelopmentComponent } from './web-development/web-development.component';
import { UiUxDesignComponent } from './ui-ux-design/ui-ux-design.component';
import { DigitalMarketingComponent } from './digital-marketing/digital-marketing.component';
import { QaTestingComponent } from './qa-testing/qa-testing.component';
import { DataAnalyticsComponent } from './data-analytics/data-analytics.component';
import { AiAsAServiceComponent } from './ai-as-a-service/ai-as-a-service.component';
import { ItConsultingComponent } from './it-consulting/it-consulting.component';

export const COMPANY_SERVICES_ROUTES: Routes = [
    {path: '', component: ServicesContainerComponent, children: [
        {path:'custom-software-development',component: SoftwareDevelopmentComponent},
        {path:'mobile-app-development',component: MobileAppDevelopmentComponent},
        {path:'web-development',component: WebDevelopmentComponent},
        {path:'ui-ux-design',component: UiUxDesignComponent},
        {path:'digital-marketing',component: DigitalMarketingComponent},
        {path:'testing-qa',component: QaTestingComponent},
        {path:'data-engineering',component: DataAnalyticsComponent},
        {path:'ai-as-a-service',component: AiAsAServiceComponent},
        {path:'it-consulting',component: ItConsultingComponent}
    ]}
]